import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Select, Space, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { MetricDropdown } from '@components/noc-metric-panel';
import { setMode } from '@store/noc/base/actions';
import { nocModeSelector } from '@store/noc/base/selectors';
import { navigateToTrends } from '@store/noc/drawer/actions';
import { sharingSelector } from '@store/noc/sharing/selectors';
import RemoveDashboardPopup from '@components/common/Dashboard/RemoveDashboardPopup';
import useContainerRef from '@src/hooks/utils/useContainerRef';
import useShareSet from '@components/share/useShareSet';
import { SHARE_SERVICE_DASHBOARD_KEYS } from '@components/share/utils';
import SampledDataWarning from '@components/common/SampledDataWarning';
import { NocFilterItems, NocViewItems } from './utils';
import Time from './Time';
import { SummaryWrapper } from '../../styled';
import { useDetectError } from '@components/noc-metric-panel/useDetectError';
import ActionPopover from '../../ActionPopover';
import Actions from './PopoverContent/Actions';
import NOCSetting from './PopoverContent/NOCSetting';

interface IProps {
  setShowFilterPanel: any;
  pageType: number;
  isSharing: boolean;
  currentShareId: number;
  pageKeyForSaveService: string;
  setView(view: string): string;
}
// eslint-disable-next-line react/display-name
export default (props: IProps) => {
  const {
    setShowFilterPanel,
    setView,
    pageType,
    isSharing,
    currentShareId,
    pageKeyForSaveService,
  } = props;
  const dispatch = useDispatch();
  const mode = useSelector(nocModeSelector);
  const navigate = useNavigate();
  const location = useLocation();
  const { isError } = useDetectError();

  const modeNode = useContainerRef();
  const filterNode = useContainerRef();

  const sharingState = useSelector(sharingSelector);

  useShareSet({ pageKey: SHARE_SERVICE_DASHBOARD_KEYS.NOC, state: sharingState });

  const onNocViewSelectHandler = (mode: string | string[]) => {
    dispatch(setMode(mode));
  };

  const onNocFilterSelectHandler = ({ key }) => {
    if (key === 'saved-filter') {
      setShowFilterPanel(true);
    } else {
      dispatch(
        navigateToTrends({
          navigate,
          location,
        }),
      );
    }
  };

  return (
    <SummaryWrapper $mode={mode}>
      {/*
        This component and all warm up related code can be removed,
        as with new V3 realtime warm up for transient filters are not required.
        <Notifier />
      */}
      <SampledDataWarning />

      <Space>
        <Button onClick={() => setView('threshold')} disabled={isError}>
          View Threshold
        </Button>
        <div ref={modeNode.containerRef}>
          <Select
            value={mode}
            onChange={onNocViewSelectHandler}
            options={NocViewItems}
            style={{ width: 170 }}
            optionLabelProp="label"
            getPopupContainer={modeNode.getContainer}
          />
        </div>

        <div ref={filterNode.containerRef}>
          <Dropdown
            menu={{ items: NocFilterItems, onClick: onNocFilterSelectHandler }}
            trigger={['click']}
            getPopupContainer={filterNode.getContainer}
          >
            <Button>
              Filters
              <DownOutlined style={{ color: 'rgba(0, 0, 0, 0.25)', fontSize: 12 }} />
            </Button>
          </Dropdown>
        </div>

        <MetricDropdown />
        <Time />
        <ActionPopover>
          <NOCSetting />
          <Actions
            pageKeyForSaveService={pageKeyForSaveService}
            currentShareId={currentShareId}
            pageType={pageType}
            isSharing={isSharing}
          />
        </ActionPopover>
      </Space>
      <RemoveDashboardPopup id={currentShareId} />
    </SummaryWrapper>
  );
};
